import { Belender } from "@pepper/belender-react";
import dayjs from "dayjs";
export interface AnalyticsParams {
  [key: string]: any;
}

export enum AnalyticsEventType {
  try_exit = "try_exit",
  back_exit = "back_exit",
  event_ko = "event_ko",
  loan_refused = "loan_refused",
  resumption = "resumption",
  simulation = "simulation",
  edit_simulation = "edit_simulation",
  change_simulation = "change_simulation",
  continue_entry = "continue_entry",
  begin_transaction = "begin_transaction",
  back_entry = "back_entry",
  belender_unavailable = "belender_unavailable",
  continue_pdata = "continue_pdata",
  continue_ldata = "continue_ldata",
  manual_input_available = "manual_input_available",
  continue_shipping = "continue_shipping",
  continue_ocr = "continue_ocr",
  send_ocr = "send_ocr",
  invalid_ocr = "invalid_ocr",
  valid_ocr = "valid_ocr",
  show_legal_bel = "show_legal_bel",
  invalid_phone_bel = "invalid_phone_bel",
  retry_phone_bel = "retry_phone_bel",
  resend_sms_bel = "resend_sms_bel",
  pin_error_bel = "pin_error_bel",
  continue_bel = "continue_bel",
  add_payment_info = "add_payment_info",
  continue_payment = "continue_payment",
  payment_error = "payment_error",
  show_contract = "show_contract",
  resend_otp = "resend_otp",
  pin_error = "pin_error",
  continue_signature = "continue_signature",
  verify = "verify",
  purchase = "purchase",
  generate_lead = "generate_lead",
}

// Tags de sesión de Clarity (dimensiones, no eventos)
export enum ClarityTagType {
  document_type = "document_type",
}

export interface GTMTimeElapse {
  initTime: dayjs.Dayjs;
  finishTime: dayjs.Dayjs;
}

export interface AnalyticsGeneralEventModel {
  step_number?: number;
  time_elapsed: number;
}

export interface AnalyticsEventModel {
  flow_step: string;
  is_customer: boolean;
  application: string;
  product: string;
  amount: string;
}

export interface SendLoanRefusedEvent {
  denial_step: DenialStep;
}

export enum DenialStep {
  CUST = "CUST",
  DEC = "DEC",
  PAC = "PAC",
}

export interface SimulationModel {
  simulation_amount: number;
  simulation_max_term: number;
  simulation_min_term: number;
  simulation_term_count: number;
  simulation_term: number;
  simulation_offer_count: number;
  simulation_cex_available: boolean;
  simulation_sus_available: boolean;
  simulation_pls_available: boolean;
}

export interface ContinueEntryModel extends AnalyticsGeneralEventModel {
  simulation_amount: number;
  simulation_term: number;
  simulation_tae: number;
  simulation_tin: number;
  simulation_regular_fee: number;
  simulation_first_fee: number;
  simulation_total_cost: number;
  simulation_opening_fee: number;
  simulation_opening_fee_type: string;
  simulation_flow_step: string;
}

export interface ItemModel {
  item_id: string;
  item_name: string;
}

export interface BeginTransactionModel {
  currency: string;
  value: number;
  items: ItemModel[];
}

export enum BelenderType {
  PROFILE = "PROFILE",
  UNAVAILABLE = "UNAVAILABLE",
}

export interface BelenderUnavailabeModel {
  type: BelenderType;
}

export interface ContinuePDataModel extends AnalyticsGeneralEventModel {
  cust_age_segment: string;
  cust_birth_country: string;
  cust_nationality: string;
  cust_email_domain: string;
  cust_classification: string;
  prop_require_documentation: boolean;
  prop_require_labor_data: boolean;
  prop_require_secure_payment: boolean;
  prop_require_require_address_data: boolean;
  prop_require_enrichment_personal_finances: boolean;
  prop_source_application: string;
  prop_product: string;
  prop_amount: number;
  prop_refinanced_amount?: number;
}

export interface ContinueLDataModel extends AnalyticsGeneralEventModel {
  cust_contract_type: string;
  cust_monthly_income: string;
  cust_province: string;
  cust_postal_code: string;
  used_manual_input: boolean;
}

export enum ContinueModeType {
  SMS = "SMS",
  EMAIL = "EMAIL",
  SAMEDEVICE = "SAMEDEVICE",
}

export interface ContinueShippingModel extends AnalyticsGeneralEventModel {
  continue_mode: ContinueModeType | string;
}

export enum OcrAccessMode {
  SMS = "SMS",
  EMAIL = "EMAIL",
  QR = "QR",
}

export interface SendOcrModel {
  access_mode: OcrAccessMode;
}

export enum OcrDeviceType {
  SAMEDEVICE = "SAMEDEVICE",
  CLIENT = "CLIENT",
}

export interface InvalidOcrModel extends AnalyticsGeneralEventModel {
  reason: string;
  third: string;
  device: OcrDeviceType;
}

export interface ValidOcrModel extends AnalyticsGeneralEventModel {
  third: string;
  device: OcrDeviceType;
}

export interface PinErrorBelModel extends AnalyticsGeneralEventModel {
  attemp_number: number;
}

export interface AddPaymentInfoModel {
  currency: string;
  value: number;
  items: ItemModel[];
}

export enum PaymentType {}
export interface ContinuePaymentModel extends AnalyticsGeneralEventModel {
  payment_type: string;
  has_previous_cards: boolean;
  amount: number;
  third: string;
}

export interface ContinueSignatureModel extends AnalyticsGeneralEventModel {
  third: string;
}

export interface PurchaseModel {
  currency: string;
  transaction_id: string;
  value: number;
  items: ItemModel[];
}

export interface GenerateLeadModel {
  currency: string;
  value: number;
}
